import React from 'react';
import './About.css';

const About = () => {
  return (
    <div className="about-container">
      <h1 className="about-header after:w-[100px]">About CIP</h1>

      <section className="about-section">
        <h2>Our Vision</h2>
        <p>
          Centre for Interdisciplinary Programs serves as a bridge between traditional academic departments at IIT Hyderabad. Main goals of the centre include
        </p>
        <ul className="list-disc pl-5 mt-2 mb-4">
          <li>Initiate and sustain new interdisciplinary programs</li>
          <li>Train human resources in new and emerging</li>
          <li>Promote interdisciplinary research through joint supervision</li>
          <li>Engage with students, faculty and scientists from diverse disciplines</li>
          <li>Incubate new ‘Centres of Excellence’.</li>
        </ul>
        <p>
          The long term vision of CIP is to foster scientific advances in interdisciplinary areas that couldn’t be done in any other way.
        </p>
      </section>

      <section className="about-section">
        <h2>Our Mission</h2>
        <p>
          Centre for Interdisciplinary Programs (CIP) was created with the mission of fostering collaboration and integration across different academic disciplines at IIT Hyderabad. CIP@ IIT Hyderabad envisions to create new paradigms in education, integrating techniques, tools and science from multi and cross - disciplinary expertise on IITH campus to address complex and multifaceted challenges.
        </p>
      </section>

      <section className="about-section">
        <h2>What We Do</h2>
        <div className="about-grid">
          <div className="about-card">
            <h3>Interdisciplinary Research</h3>
            <p>CIP offers an Interdisciplinary PhD program enabling students to work with two research supervisors from different fields. For admissions into the 2026 cycle,
              visit the {" "}
              <a href="https://iith.ac.in/phdadmissions/" target="_blank" rel="noopener noreferrer"> IITH ID PhD Admissions page
  </a>{" "}
          </p>
          </div>
          <div className="about-card">
            <h3>Academic Programs</h3>
            <p>CIP Offers a number of unique and specialized interdisciplinary M.Tech programs and an M.Sc. program in Medical Physics. For more information about various Academic Programs, visit the Programs page.</p>
          </div>
          <div className="about-card">
            <h3>Collaboration</h3>
            <p> CIP nurtures collaborations between faculty across different departments of IIT Hyderabad through its unique academic and research programs. Furthermore, CIP collaborates with leading organizations in Hyderaba such as the LV Prasad Eye Institute, Basavatarakam Indo American Cancer Hospital & Research Institute, Asian Institute of Gasteroenterology, Basavatarakam Indo American Cancer Hospital & Research Institute, Krishna Institute of Medical Sciences, etc.  </p>
          </div>
          <div className="about-card">
            <h3>Innovation</h3>
            <p>Learn more about the unique and innovative programs of CIP such as the Medical Device Innovations, Integrated Circuits and Microsystems Packaging, or Ophthalmic Engineering.</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About; 
